module.exports = __webpack_public_path__ + "img/equipos-de-sala-img-5.bd5d14e6.jpg";